import ApiService from "@/services/Api"
import ErrorHandlerService from "@/services/ErrorHandler"

class ErrorReportService {
	async report (endpoint: string): Promise<void> {
		try {
			await ApiService.post("/error-report", { endpoint })
		} catch (error) {
			ErrorHandlerService.handle(error as Error)
		}
	}
}

export default new ErrorReportService()
